(function () {
  var pagetop = document.querySelector('.js-pagetop')
  if(!pagetop) return false

  var body = window.document.body;
  var html = window.document.documentElement;
  var scrollLink = document.querySelector('.js-scroll')

  function scroll() {
    var scrollTop = body.scrollTop || html.scrollTop;
    if (scrollTop == 0) {
      pagetop.classList.remove('is-show')
      scrollLink.classList.remove('is-scroll')
    } else {
      pagetop.classList.add('is-show')
    }
  }

  window.addEventListener('scroll', scroll)
  scroll()

  scrollLink.addEventListener('click', pagetopClick)
  
  function pagetopClick() {
    scrollLink.classList.add('is-scroll')
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

}());
